import { apiGET, apiPOST } from '../utils/adapterFunctions'

export const optInPromotion = async (link) => {
  return await apiPOST(`/promotions/opt-in?link=${link}`, null, {
    hasNoData: false,
  })
}

export const optedInPromotions = async () => {
  return await apiGET('/promotions/opted-in')
}
